module.exports = __webpack_public_path__ + "static/img/IMG_20241023_110244.9529de48.jpg";